/**
 * Analytics / verification — all optional, env-driven.
 * PostHog project key is public by design; set REACT_APP_POSTHOG_KEY in Vercel to enable (no hardcoded fallback).
 */
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';

export const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';

export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '';

export const GOOGLE_SITE_VERIFICATION = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || '';
